import { useRouter } from 'next/router'
import { useState } from 'react'

import { TabPanel, TabPanels, Tabs } from '@wartek-id/tabs'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'

import CustomTabList from '../../components/CustomTabList'
import {
  tabNamesSubmitted,
  tabNamesV3Submitted,
} from 'app/KinerjaPage/constants'
import TabHasilKerjaUtama from './TabHasilKerjaUtama'
import TabHasilKerjaTambahan from './TabHasilKerjaTambahan'
import TabPerilakuKerja from './TabPerilakuKerja'
import useToggleSdkContext from 'utils/useToogleSdk'
import FlatKinerjaPerencanaanApprovedView from 'app/KinerjaPage/pages/PerencanaanApproved/FlatApprovedView'
import { usePengelolaanKinerjaBaseUrl } from 'app/KinerjaShared/hooks/usePengelolaanKinerjaBaseUrl'

import type { Kinerja } from 'types/kinerja'

interface KinerjaPerencanaanApprovedAppProps {
  skp: Kinerja
  isSKPFetched: boolean
  isDeleteSKPEnabled?: boolean
}

enum TabIndex {
  HASIL_KERJA_UTAMA = 0,
  HASIL_KERJA_TAMBAHAN = 1,
  PERILAKU_KERJA = 2,
}

function KinerjaPerencanaanApprovedApp({
  skp,
  isSKPFetched,
  isDeleteSKPEnabled = false,
}: KinerjaPerencanaanApprovedAppProps) {
  const router = useRouter()
  const toggles = useToggleSdkContext()
  const baseUrl = usePengelolaanKinerjaBaseUrl()

  const isTugasPokokEnabled =
    toggles?.['kinerja-tugas-pokok-enabled'] === true && skp?.tahun > 2024

  const tabNames = isTugasPokokEnabled ? tabNamesV3Submitted : tabNamesSubmitted

  const [activeTabIndex, setActiveTabIndex] = useState<number>(
    TabIndex.HASIL_KERJA_UTAMA
  )

  const backToHomeKinerja = () => {
    router.push(baseUrl)
  }

  return (
    <div className="py-[50px] px-[116px]">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <Icon onClick={backToHomeKinerja} data-testid="icon-back">
            arrow_back
          </Icon>
          <Text variant="display-md">Perencanaan Kinerja</Text>
        </div>
      </div>

      {!isSKPFetched ? (
        <Shimmer data-testid="loading-spinner-skp" />
      ) : (
        <div className="bg-white rounded-md mt-8 mb-[78px]">
          {isTugasPokokEnabled ? (
            <FlatKinerjaPerencanaanApprovedView
              skp={skp}
              isDeleteSKPEnabled={isDeleteSKPEnabled}
            />
          ) : (
            <Tabs onChange={setActiveTabIndex} selectedIndex={activeTabIndex}>
              <CustomTabList
                activeTabIndex={activeTabIndex}
                tabs={tabNames}
                disableInactiveTab
              />
              <TabPanels>
                <TabPanel>
                  <TabHasilKerjaUtama
                    skp={skp}
                    onClickNext={() =>
                      setActiveTabIndex(TabIndex.HASIL_KERJA_TAMBAHAN)
                    }
                  />
                </TabPanel>
                <TabPanel>
                  <TabHasilKerjaTambahan
                    skp={skp}
                    onClickNext={() =>
                      setActiveTabIndex(TabIndex.PERILAKU_KERJA)
                    }
                  />
                </TabPanel>
                <TabPanel>
                  <TabPerilakuKerja
                    skp={skp}
                    isDeleteSKPEnabled={isDeleteSKPEnabled}
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          )}
        </div>
      )}
    </div>
  )
}

export default KinerjaPerencanaanApprovedApp
